<div fxLayout="row" class="background">
  <div fxFlex="80" fxFlexOffset="10%">

    <section id="header">
      <h1 class="h1Header">ADMINISTRAR COMERCIOS</h1>
    </section>

    <section id="table">
      <mat-card class="mat-elevation-z0">
        <div>
          <button mat-flat-button class="add-btn" (click)="addShop()">Agregar nuevo</button>
        </div>

        <table mat-table [dataSource]="allStores" class="mat-elevation-z0">
          <ng-container matColumnDef="imagen">
            <th mat-header-cell *matHeaderCellDef class="table-header">IMAGEN</th>
            <td mat-cell *matCellDef="let store"> <img class="logo" [src]="store.dsImg">
            </td>
          </ng-container>

          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef class="table-header">NOMBRE</th>
            <td mat-cell *matCellDef="let store">
              {{store.dsName}}<br />
              <mat-hint>{{store.dsStoreTypeName}}</mat-hint>
            </td>
          </ng-container>

          <ng-container matColumnDef="telefono">
            <th mat-header-cell *matHeaderCellDef class="table-header">TELÉFONO</th>
            <td mat-cell *matCellDef="let store">
              {{store.dsPhone}}
            </td>
          </ng-container>

          <ng-container matColumnDef="ciudad">
            <th mat-header-cell *matHeaderCellDef class="table-header">CIUDAD</th>
            <td mat-cell *matCellDef="let store">
              {{store.dsCityName}}
            </td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
            <td mat-cell *matCellDef="let store" class="table-content">
                <mat-slide-toggle [(ngModel)]="store.isEnabled" (click)="enableDisable(store.cdStore, store.isEnabled)"></mat-slide-toggle>
            </td>
          </ng-container>

          <ng-container matColumnDef="opciones">
            <th mat-header-cell *matHeaderCellDef class="table-header">OPCIONES</th>
            <td mat-cell *matCellDef="let store">
              <button mat-mini-fab [ngClass]="{'open-btn': store.isOpen, 'close-btn': !store.isOpen}" 
                (click)="openCloseShop(store.cdStore, store.isOpen)"
                #tooltip="matTooltip"
                matTooltip="Abrir/Cerrar">
                <mat-icon>adjust</mat-icon>
              </button>
              <button mat-mini-fab [ngClass]="{'trend-btn': store.isTrending, 'trend-down-btn': !store.isTrending}"
                (click)="trending(store.cdStore, store.isTrending)"
                #tooltip="matTooltip"
                matTooltip="Agregar a tendencia">
                <mat-icon>trending_up</mat-icon>
              </button>
              <button mat-mini-fab class="login-btn" (click)="loginAsShop(store.cdStore)"
              #tooltip="matTooltip"
              matTooltip="Ingresar como comercio">
                <mat-icon>login</mat-icon>
              </button>
              <button mat-mini-fab class="edit-btn" (click)="editShop(store.cdStore)"
              #tooltip="matTooltip"
              matTooltip="Editar">
                <mat-icon>create</mat-icon>
              </button>
              <button mat-mini-fab class="delete-btn"(click)="deleteShop(store.cdStore)"
              #tooltip="matTooltip"
              matTooltip="Eliminar">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </mat-card>
    </section>
  </div>
</div>
